module.exports = __webpack_public_path__ + "img/pro4.f44b9d8b.png";